import React, {Component} from 'react';
import {Container, Card, CardHeader, CardBody, CardFooter, Breadcrumb, BreadcrumbItem} from 'reactstrap';
import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies()

const qs = require('qs');
const prebase = window.location.protocol + '//' + window.location.host;
const base = (prebase.indexOf('3000') > -1) ? prebase.replace('3000', '8080') : prebase;

export default class VitalsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pid: props.match.params.pid,
            vitals: [],
        };
        this.loadPatient();
    }

    loadPatient() {
        let authToken = cookies.get('auth_token')
        axios({
            method: 'get',
            url: `${base}/api/patients/patient/${this.state.pid}`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${authToken}`
            },
            withCredentials: true,
        }).then(response => {
            this.setState({
                patient: response.data[0],
            }, this.loadVitals);
        }).catch(error => {
            console.log(error);
        })
    }
    
    loadVitals() {
        let authToken = cookies.get('auth_token')
        axios({
            method: 'get',
            url: `${base}/api/patients/vitals/${this.state.pid}/list/`,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Token ${authToken}`
            },
            withCredentials: true,
        }).then(response => {
            this.setState({
                vitals: response.data,
            })
        }).catch(error => {
            console.log(error);
        })
    }

    render() {
        let patient = this.state.patient ? this.state.patient.fields : {};
        return (
            <Container>
                <Card>
                    <CardHeader>
                        <h2 className="float-left">Vital Records</h2>
                        <a className="mui-btn mui-btn--raised float-right" href={"/admin/vitals?" + qs.stringify({pid: this.state.pid, then: `/admin/patients/${this.state.pid}/vitals/list`})}>Update Vitals</a>
                    </CardHeader>
                    <CardBody>
                        {this.state.vitals.map((vital) => (
                            <a key={vital.pk} href={`/admin/patients/${this.state.pid}/vitals/${vital.pk}`}>
                                <Card key={vital.pk}> 
                                    <CardBody>
                                    <p className="h4 float-left">{patient.LastName + ', ' + patient.FirstName}</p>
                                    <p className="h5 float-right">{vital.fields.updated}</p>
                                    </CardBody>
                                </Card>
                            </a>
                        ))}
                    </CardBody>
                    <CardFooter>
                    </CardFooter>
                </Card>
            </Container>
        )
    }
}
